import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { DEFAULT_LOCALE } from '~/i18n/config'
import { useLocalisation } from '../localisation'
import { UserValue } from './User.types'
import { usePlatformTheme } from '../theme'

const getLocaleFromUser = (userData: UserValue) => {
  if (userData?.person?.locale) {
    if (userData.person.locale.length > 2) {
      return userData.person.locale
    }
    if (
      userData.person.locale.toLowerCase() === 'en' &&
      userData.person.countryOfResidence?.identifier.toLowerCase() === 'us'
    ) {
      return 'en-US'
    }
  }

  return DEFAULT_LOCALE
}

const useUserLocaleResolver = (userData?: UserValue) => {
  const { locale } = useLocalisation()
  const router = useRouter()
  const { isWhitelabel } = usePlatformTheme()

  useEffect(() => {
    if (userData) {
      const resolvedLocale = getLocaleFromUser(userData)
      // Runs for whitelabel only and redirects to user preferred locale - covers en-US
      if (isWhitelabel && resolvedLocale !== locale) {
        const { pathname, asPath, query } = router
        // change just the locale while preserving all routing information
        router.replace({ pathname, query }, asPath, { locale: resolvedLocale })
      }
    }
  }, [isWhitelabel, locale, router, userData])
}

export default useUserLocaleResolver
